// Author lidongxu
// Date 2023-12-04 14:56:54

import * as model from "@/model/sithMes/stool/SithMesStoolTransferTicketGenerationRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolTransferTicketGenerationRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
